'use client';

import { motion } from 'motion/react';

export default function TrustedBy() {
  return (
    <section className="border-y border-zinc-800/50 bg-[#0f0f0f] py-12">
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-24">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-8 text-center text-[10px] font-bold tracking-[0.2em] text-zinc-500"
        >
          TRUSTED BY PROFESSIONAL ENTITIES GLOBALLY
        </motion.p>
        
        <div className="flex flex-wrap justify-center gap-8 opacity-50 grayscale md:gap-16">
          {[1, 2, 3, 4, 5].map((i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="flex h-12 w-24 items-center justify-center rounded bg-zinc-800/50"
            >
              <div className="h-4 w-4 rounded-full bg-zinc-600" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
